import React from 'react'
import AccountLayout from '../../components/AccountLayout'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../../routes'
import Configuration from '../../Services/Api/Configuration'
import DraftsPageContent from '../../components/DraftsPageContent'

const Templates = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Page.invoices.templates.title' })}
           pathname={window.location.origin + NamedRoutes.templates}
           titleTemplate={intl.formatMessage({ id: 'eInvoice' })}
           description={intl.formatMessage({ id: 'Page.invoices.templates.title' })}
      />

      <AccountLayout permission={Configuration.permissions.invoice.view} content={
        <DraftsPageContent entityName={'templates'}/>
      }/>
    </>
  )
}

export default Templates
